import React, { useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AI_CHATBOT_STATUS } from '../../constants/aiChatbot';
import { StartButton } from './StartButton/StartButton';
import { Widget } from './Widget';
import styles from './AiChatbot.module.scss';
import useOnClickOutside from '../../hooks/useOnClickOutside';
import { adjustActionsPopupStatus, adjustAiChatbotStatus } from '../../store/actions/aiChatbot';

export function AiChatbot() {
  const { status, actionsPopupStatus } = useSelector((state) => state.aiChatbot);
  const ref = useRef();
  const dispatch = useDispatch();

  useOnClickOutside(
    ref,
    useCallback(() => {
      if (actionsPopupStatus === AI_CHATBOT_STATUS.OFF) {
        dispatch(adjustAiChatbotStatus(AI_CHATBOT_STATUS.OFF));
        dispatch(adjustActionsPopupStatus(AI_CHATBOT_STATUS.OFF));
      }
    }, [actionsPopupStatus]), // eslint-disable-line
  );
  return (
    <>
      {status === AI_CHATBOT_STATUS.OFF && <StartButton />}

      {status === AI_CHATBOT_STATUS.ON && (
        <div className={styles.container} ref={ref}>
          <Widget />
        </div>
      )}
    </>
  );
}
